module.exports = __webpack_public_path__ + "img/p2e-box.78540be3.svg";